import React, { useState } from "react";
import api from "../services/api";

const TotpSetup = () => {
  const [qrDataUrl, setQrDataUrl] = useState(null);
  const [manualKey, setManualKey] = useState("");
  const [code, setCode] = useState("");
  const [status, setStatus] = useState("idle"); // idle | qr_shown | verifying | success | error
  const [message, setMessage] = useState("");

  const handleStartSetup = async () => {
    try {
      setStatus("loading");
      const res = await api.post("/mfa/totp/setup");
      setQrDataUrl(res.data.qrDataUrl);
      setManualKey(res.data.manualEntryKey);
      setStatus("qr_shown");
    } catch (err) {
      setStatus("error");
      setMessage(err.response?.data?.message || "Failed to start setup");
    }
  };

  const handleVerify = async () => {
    try {
      setStatus("verifying");
      await api.post("/mfa/totp/verify-setup", { code });
      setStatus("success");
      setMessage("Authenticator app linked successfully.");
    } catch (err) {
      setStatus("qr_shown");
      setMessage(err.response?.data?.message || "Invalid code, try again.");
    }
  };

  return (
    <div style={styles.card}>
      <h3 style={styles.title}>Authenticator App</h3>
      <p style={styles.subtitle}>
        Link an authenticator app (Google Authenticator, Authy, etc.) as your final login step.
      </p>

      {status === "idle" && (
        <button style={styles.button} onClick={handleStartSetup}>
          Set Up Authenticator App
        </button>
      )}

      {status === "loading" && <p>Loading...</p>}

      {(status === "qr_shown" || status === "verifying") && (
        <>
          <img src={qrDataUrl} alt="Scan this QR code" style={styles.qr} />
          <p style={styles.manualKey}>Manual entry key: <b>{manualKey}</b></p>

          <input
            type="text"
            placeholder="Enter 6-digit code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            style={styles.input}
            maxLength={6}
          />

          <button
            style={styles.button}
            onClick={handleVerify}
            disabled={status === "verifying" || code.length !== 6}
          >
            {status === "verifying" ? "Verifying..." : "Confirm & Enable"}
          </button>
        </>
      )}

      {message && (
        <p style={{ ...styles.message, color: status === "error" ? "#b91c1c" : "#166534" }}>
          {message}
        </p>
      )}
    </div>
  );
};

const styles = {
  card: {
    background: "#fff",
    borderRadius: "16px",
    padding: "24px",
    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
    maxWidth: "420px",
    marginTop: "20px",
  },
  title: { margin: "0 0 6px 0", fontSize: "18px", color: "#1e293b" },
  subtitle: { margin: "0 0 16px 0", fontSize: "14px", color: "#64748b" },
  button: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "none",
    background: "#2563eb",
    color: "#fff",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "10px",
  },
  qr: { width: "200px", height: "200px", marginBottom: "10px" },
  manualKey: { fontSize: "12px", color: "#64748b", marginBottom: "14px", wordBreak: "break-all" },
  input: {
    display: "block",
    padding: "10px 12px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    fontSize: "16px",
    marginBottom: "10px",
    width: "100%",
    boxSizing: "border-box",
  },
  message: { marginTop: "14px", fontSize: "13px", fontWeight: "600" },
};

export default TotpSetup;